<template>
  <span>
    <button
      id="ordersButton"
      ref="ordersButton"
      class="btn btn-sm"
      type="button"
      @click="toggleOrdersPopover"
    >
      <span
        v-if="pendingOrdersAmount > 0"
        class="order-button-text"
        v-html=" $t('ORDERS_PENDING_AMOUNT', {amount: pendingOrdersAmount })"
      /> {{ $t('NUMBER_ORDERS') }}
    </button>
    <popover
      v-model="showOrdersPopover"
      custom-class="search-popover"
      placement="bottom"
      :auto-placement="false"
      trigger="manual"
      target="#ordersButton"
      @show="showOrdersPopover = true"
      @hide="showOrdersPopover = false"
    >
      <template slot="popover">
        <NumberOrdersPopup
          v-if="showOrdersPopover"
          @closeModal="closeModal"
        />
      </template>
    </popover>
  </span>
</template>

<script>
import NumberOrdersPopup from './NumberOrdersPopup';
import { mapActions, mapState, mapGetters } from 'vuex';
import { GET_NUMBER_ORDERS, GET_NUMBER_ORDER, GET_PENDING_NUMBER_ORDERS, CANCEL_NUMBER_ORDER } from '../../store/actionTypes';
import messages from '../../locales';

export default {
  components: {
    NumberOrdersPopup,
  },
  data() {
    return {
      tagsPopoverVisible: false,
      showOrdersPopover: false,
      orderRefreshInterval: null,
    };
  },
  computed: {
    ...mapGetters('number', [
      'pendingOrdersAmount',
    ]),
  },
  mounted() {
    this.getPendingOrders();
    this.pollData();
  },
  beforeDestroy() {
    clearInterval(this.orderRefreshInterval);
  },
  methods: {
    ...mapActions('number', {'getPendingOrders': GET_PENDING_NUMBER_ORDERS}),
    toggleOrdersPopover() {
      this.showOrdersPopover = !this.showOrdersPopover;
      return;
    },
    closeModal() {
      this.showOrdersPopover = false;
      return;
    },
    pollData () {
      this.orderRefreshInterval = setInterval(() => {
        this.getPendingOrders();
      }, 15000);
    },
  },
  i18n: {
    messages,
    locale: 'en'
  }
};
</script>

<style  lang="scss" scoped>

.popover.search-popover {
  max-width: 30%;
  min-width: 30%;
  left: auto !important;
  right: 0 !important;

  .close {
    margin-top: -4px;
  }

  .popover-title {
    background-color: var(--component-in-app-notifications__popover);
  }
  background-color: var(--component-in-app-notifications__popover);
  &.bottom {
    @include setPopoverArrowColor(
      'border-bottom-color',
      var(--component-in-app-notifications__popover)
    );
    margin-right: 40px;
    .arrow {
      left: 90%;
    }
  }

  &.right {
    @include setPopoverArrowColor(
      'border-right-color',
      var(--component-in-app-notifications__popover)
    );
  }

  .popover-content {
    padding: 1px;
  }
  .form-group {
    padding-right: 0;
    padding-left: 0;
  }

  @media (max-width: 575.98px) {
    max-width: 80%;
    min-width: 80%;
    .close {
      margin-top: -7px;
    }
  }
}
</style>